import { gql } from '@apollo/client'
import {
    ManufacturerProductBimLinkDetailFragment,
    ManufacturerProductCatalogDetailFragment,
    ManufacturerProductDetailFragments,
    ManufacturerProductSpecDocDetailFragment,
} from '../fragments/productDetail.fragments'

export const AllProductTypesSampleQuery = gql`
    query allProductTypesSampleQuery($masterId: String!) {
        allProductTypes(masterId: $masterId)
    }
`

export const AllProductsQuery = gql`
    query allProductsQuery($masterId: String!) {
        allProducts(masterId: $masterId) @client
    }
`

// gets all recent products across our content20
export const RecentProductsQuery = gql`
    query recentProductsQuery {
        listingSearch(
            input: {
                facets: [
                    { name: "isActive", values: ["true"] }
                    { name: "submissionStatus", values: ["Completed"] }
                    {
                        name: "listingLevels"
                        values: [
                            "Premium"
                            "Premium MasterSpec"
                            "PremiumMasterSpec"
                            "PremiumProprietary"
                        ]
                    }
                ]
                top: 4
                orderBy: "lastUpdated desc"
                skip: 0
                logEventSource: "BpmRecentProducts"
            }
        ) {
            matches {
                firmId
                firmName
                categories
                productName
                firmLogoUrl
                listingId
                images {
                    filename
                }
            }
        }
    }
`

export const ProductListingsQuery = gql`
    query productListingsQuery(
        $listingSearchInput: ManufacturerProductSearchInput!
    ) {
        listingSearch(input: $listingSearchInput) {
            facets {
                name
                values {
                    count
                    value
                }
            }
        }
    }
`

export const GetProductHistoryHeader = gql`
    query getListingDetail($listingIdInput: GetListingDetailInput!) {
        getListingDetail(input: $listingIdInput) {
            listingId
            productName
            productType
            sectionName
            firmName
        }
    }
`

export const ProductListingDetailsQuery = gql`
    query getListingDetail($listingIdInput: GetListingDetailInput!) {
        getListingDetail(input: $listingIdInput) {
            assignedBPMUsers {
                ...assignedBPMUsersFragment
            }
            assignedContactUsers {
                ...assignedBPMUsersFragment
            }
            assignedDeltekUsers {
                ...assignedDeltekUsersFragment
            }
            model
            productId
            listingId
            productName
            firmLogoUrl
            firmId
            firmName
            firmPartnershipTypes
            categories
            specAgentProductTypeId
            productType
            submissionStatus
            isActive
            isPremiumPlus
            buildingTypes
            firstPublished
            lastPublished
            shortDescription
            longDescription
            sectionNumber
            sectionTitle
            sectionName
            type
            lastUpdated
            isForNonMasterspecFamily
            properties {
                ...propertiesFragment
            }
            images {
                ...imagesFragment
            }
            videos {
                ...videosFragment
            }
            firmPartnershipTypes
            webLinks {
                ...webLinksFragment
            }
            catalogs {
                ...manufacturerProductCatalogDetailFragment
            }
            manufacturerDocs {
                ...manufacturerProductSpecDocDetailFragment
            }
            bimLinks {
                ...manufacturerProductBimLinkDetailFragment
            }
            partnershipLinks {
                ...partnershipLinksFragment
            }
            canAutoGenerateProductSpecification
            contentLibrary
        }
    }
    ${ManufacturerProductDetailFragments.assignedBPMUsersFragment}
    ${ManufacturerProductDetailFragments.assignedDeltekUsersFragment}
    ${ManufacturerProductDetailFragments.webLinksFragment}
    ${ManufacturerProductDetailFragments.imagesFragment}
    ${ManufacturerProductDetailFragments.videosFragment}
    ${ManufacturerProductDetailFragments.propertiesFragment}
    ${ManufacturerProductCatalogDetailFragment}
    ${ManufacturerProductSpecDocDetailFragment}
    ${ManufacturerProductBimLinkDetailFragment}
    ${ManufacturerProductDetailFragments.partnershipLinksFragment}
`

export const ListingsGetListingProductTypeProperties = gql`
    query listingsGetListingProductTypeProperties(
        $input: GetListingProductTypePropertiesInput!
    ) {
        listingsGetListingProductTypeProperties(input: $input) {
            categories
            properties {
                ...propertiesFragment
            }
        }
    }
    ${ManufacturerProductDetailFragments.propertiesFragment}
`

// Note: I didn't create a fragment here since this is not yet reusable for now
export const GetIsManufacturerOptionDetailsRemovable = gql`
    query getManufacturerOptionDetails(
        $input: GetManufacturerOptionDetailsInput
    ) {
        getManufacturerOptionDetails(input: $input) {
            listingId
            manufacturerOptionGroupDetails {
                propertyId
                optionGroupId
                optionId
                isDetailsRemovable
                reasonForNotBeingUpdatable
            }
        }
    }
`

export const GetManufacturerProductPropertiesAutoSuggest = gql`
    query manufacturerProductPropertiesAutoSuggest(
        $input: ManufacturerProductPropertiesAutoSuggestInput
    ) {
        manufacturerProductPropertiesAutoSuggest(input: $input) {
            result {
                sectionNumber
                sectionName
                productTypePropertiesAutoSuggestResults {
                    productType
                    autoSuggestPropertyInfo {
                        propertyName
                        isPremiumPlus
                    }
                }
            }
        }
    }
`
